import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "reportIndex",
    component: () => import('@/views/reportIndex.vue')
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue")
  },
  {
    path: "/reportgenerate",
    name: "reportGenerate",
    component: () => import("@/views/reportGenerate.vue")
  },
  {
    path: "/patent/report",
    name: "patentReport",
    component: () => import("@/views/patentReport/patentReport.vue"),
    meta: {
      title: "专利报告"
    }
  },
  // {
  //   path: "/patent/report/dashboard",
  //   name: "reportDashboard",
  //   component: () => import("@/views/patentReport/reportDashboard.vue"),
  //   meta: {
  //     title: "报告大屏"
  //   }
  // },
  {
    path: "/innovation/report",
    name: "innovationReport",
    component: () => import("@/views/patentReport/patentReport-n2.vue"),
    meta: {
      title: "科创智能报告中心"
    }
  },
  {
    path: "/patent/report/dashboard",
    name: "reportDashboard",
    component: () => import("@/views/patentReport/reportDashboard-n2.vue"),
    meta: {
      title: "报告大屏"
    }
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

export default router
